const kovsentry = require('../../app/kovSentry');

class listScreen {
  constructor($scope, $ngRedux, $state, ConfirmationService, ModalWindowService) {
    'ngInject';

    this.$scope = $scope;
    this.$ngRedux = $ngRedux;
    this.$state = $state;
  }

  async $onInit() {
    const { $state } = this;
    const { $ngRedux } = this;
    this.unsubscribe = this.$ngRedux.subscribe(() => {
      const state = $ngRedux.getState();
      if (!state.newDocumentList.loading) {
        kovsentry.endLog('Load Redactie');
        kovsentry.endLog('Search Document');
        kovsentry.endLog('Delete Document');
      }
    });

  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default {
  template: require('./listScreen.html'),
  controllerAs: 'ctrl',
  bindings: {},
  controller: listScreen,
};
